import { autoinject, transient } from 'aurelia-dependency-injection';
import { I18N } from 'aurelia-i18n';
import { QueryAssignmentEnum, GetQueryAssignmentsResponse } from '../../../models/queries/queries.models';
import { QueriesClientService } from '../../../services/queries/queries-client.services';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from '../../../services/basics/notification-client.service';

@transient()
@autoinject()
export class ShareDashboardDialog {
    public queryId: number;
    public branchId: number;
    public departmentId: number;
    public roleId: number;
    public userId: number;
    public shareGlobally: boolean = false;
    public isDefault: boolean = false;
    public branchIdsToFilter: number[] = [];
    public departmentIdsToFilter: number[] = [];
    public roleIdsToFilter: number[] = [];
    public userIdsToFilter: number[] = [];

    constructor(private dialogClient: DialogClientService, private queriesClientService: QueriesClientService, private notificationService: NotificationClientService,
        private i18N: I18N) { }

    cancel() {
        this.dialogClient.hide();
    }

    share() {
        return new Promise<void>((resolve, reject) => {
            if (this.branchId == null && !this.shareGlobally) {
                this.notificationService.show(this.i18N.tr('empty-fields'), this.i18N.tr('empty-fields-description-share-dashboard'), NotificationType.Warning);
                reject();
                return;
            }
            let categoryId;
            let category;

            if (this.shareGlobally) {
                category = QueryAssignmentEnum.Global;
            }
            else if (this.userId != null) {
                categoryId = this.userId;
                category = QueryAssignmentEnum.User;
            }
            else if (this.roleId != null) {
                categoryId = this.roleId;
                category = QueryAssignmentEnum.Role;
            }
            else if (this.departmentId != null) {
                categoryId = this.departmentId;
                category = QueryAssignmentEnum.Department;
            }
            else {
                categoryId = this.branchId;
                category = QueryAssignmentEnum.Branch;
            }

            this.queriesClientService.addQueryAssignment(this.queryId, categoryId, category, this.isDefault)
                .then(response => {
                    if (response) {
                        this.notificationService.show(this.i18N.tr('successful-sharing'), this.i18N.tr('successful-sharing-description'), NotificationType.Success);
                    }
                    else {
                        this.notificationService.show(this.i18N.tr('failed-sharing'), this.i18N.tr('failed-sharing-description'), NotificationType.Error);
                    }

                    this.dialogClient.hide();
                    resolve();
                }, e => {
                    if (!e) {
                        this.notificationService.show(this.i18N.tr('error-text'), this.i18N.tr('error-sharing-description'), NotificationType.Error);
                    }
                    reject();
                })
        });
    }

    activate(model: any) {
        this.queryId = model.queryId

        this.queriesClientService.getQueryAssignments(this.queryId)
            .then((x: GetQueryAssignmentsResponse) => {
                if (x.sharedGlobally) this.shareGlobally = true;
                if (x.sharedDefaultGlobally) this.isDefault = true;
                if (x.branchItems) x.branchItems.forEach(x => this.branchIdsToFilter.push(x.id));
                if (x.departmentItems) x.departmentItems.forEach(x => this.departmentIdsToFilter.push(x.id));
                if (x.roleItems) x.roleItems.forEach(x => this.roleIdsToFilter.push(x.id));
                if (x.userItems) x.userItems.forEach(x => this.userIdsToFilter.push(x.id));
            },  () => { });
    }
}
